import { Stethoscope, Heart, Building2, Sparkles, Network, ShieldCheck } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";
import { WHY_CHOOSE } from "@/data/content";

const ICONS = { Stethoscope, Heart, Building2, Sparkles, Network, ShieldCheck };

export function WhyChoose() {
  return (
    <section id="why" data-testid="why-choose-section" className="py-24 lg:py-32 bg-ivory relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <SectionHeading
          align="center"
          chapter="05"
          overline="Why Dyntra"
          title="Why Patients Choose Dyntra Clinics"
          sub="A clinic experience designed around trust — before, during and after your visit."
        />
        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {WHY_CHOOSE.map((c, i) => {
            const Icon = ICONS[c.icon] || Sparkles;
            return (
              <Reveal key={c.title} delay={(i % 3) * 0.08}>
                <div className="group h-full rounded-3xl border border-pine/10 bg-white/70 backdrop-blur p-8 transition-all duration-500 hover:-translate-y-1.5 hover:shadow-lift hover:border-gold/40">
                  <div className="flex items-center gap-4">
                    <span className="flex h-11 w-11 items-center justify-center rounded-full bg-cream text-pine transition-colors duration-500 group-hover:bg-pine group-hover:text-gold">
                      <Icon className="h-5 w-5" strokeWidth={1.8} />
                    </span>
                    <span className="font-display text-4xl font-semibold text-pine/10 group-hover:text-gold/40 transition-colors duration-500">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                  </div>
                  <h3 className="mt-5 font-display text-xl font-semibold text-pine-deep">{c.title}</h3>
                  <p className="mt-2.5 text-sm leading-relaxed text-slate-600">{c.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
